import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Slider from "react-slick";
import { AiFillDollarCircle } from "react-icons/ai";
import { BsFillMortarboardFill } from "react-icons/bs";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa6";

const Program = () => {

  const listProgram = [
    { name:"Hospitality & Tourism (Diploma / Advanced Diploma)", desc:"Cocok banget buat kamu yang mau jadi chef, manajer hotel, event organizer, atau buka usaha sendiri.", img:"assets/images/program1.webp", degree:"Diploma / Adv. Diploma", tuition:"AUD $6,276 / semester" },
    { name:"Digital Media & IT", desc:"Skill coding, desain grafis sampai media digital yang laku keras di industri kreatif dan startup global.", img:"assets/images/program2.webp", degree:"Certificate / Diploma", tuition:"AUD $6,276 / semester" },
    { name:"Automotive & Engineering", desc:"Belajar kerja di bengkel kelas dunia, engineering, atau teknisi alat berat - skill yang dihargai tinggi di berbagai negara.", img:"assets/images/program3.webp", degree:"Certificate - Diploma", tuition:"AUD $6,276 / semester" },
    { name:"Nursing & Health Services", desc:"Dunia kesehatan terus tumbuh - lulus bisa kerja rumah sakit, klinik, atau lanjut ke studi lanjutan.", img:"assets/images/program4.webp", degree:"Diploma", tuition:"AUD $6,276 / semester" },
  ]

  const NextArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow next" onClick={onClick}>
        <FaChevronRight size={24} />
      </div>
    );
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow prev" onClick={onClick}>
        <FaChevronLeft size={24} />
      </div>
    );
  };

  const settings = {
    className: "center",
    dots: true,
    infinite: true,
    speed: 500,
    
    centerMode: false,
    centerPadding: "0px",
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,     
    responsive: [   
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0px",
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },        
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: "35px",
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },            
    ],    
  };

  return (
    <>
      <section className="section" id="program">
        <Container>
          <Row className="">
            <Col className="">
              <div className="slide-wrapper">
                <h1 className="mb-3"><b>Program Studi Unggulan</b></h1>
                  <Slider {...settings}>
                    {listProgram.map((item, id) =>(
                      <Card key={id} className=''>
                        <img
                          alt={item.name}
                          src={item.img}
                          className="img-fluid"
                        />
                        <CardBody>
                          <div className="row">
                            <div className="col-1">
                            <BsFillMortarboardFill color="#00072E" />
                            </div>
                            <div className="col">
                            <p>{item.name}</p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-1">
                            <AiFillDollarCircle color="#00072E" />
                            </div>
                            <div className="col">
                            <p>{item.tuition}</p>
                            </div>
                          </div>     
                          <div className="mt-3">{item.desc}</div>                 
                        </CardBody>
                      </Card>
                    ))}
                  </Slider>
                <p className="note">*Catatan biaya adalah estimasi & bisa berubah, tergantung program & semester.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Program;